import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "@/components/ui/dialog.tsx";
import { PropsWithChildren, ReactNode } from "react";
import { type Persona } from "@/api/personas.ts";
import { TwitterAvatar } from "@/components/twitter/TwitterAvatar";

type ContentModalProps = {
  persona: Persona;
  content: ReactNode;
  footer?: ReactNode;
};

export function ContentModal({
  persona,
  content,
  footer,
  children,
}: PropsWithChildren<ContentModalProps>) {
  return (
    <Dialog>
      <ModalContent persona={persona} content={content} footer={footer} />
      {children}
    </Dialog>
  );
}

function ModalContent({ persona, content, footer }: ContentModalProps) {
  //console.log(content)
  return (
    <DialogContent className="max-w-4xl pt-4 pb-0 mb-0 space-y-0">
      <DialogHeader className="pt-0 pb-0">
        <TwitterAvatar persona={persona} />
      </DialogHeader>
      <div className="flex flex-col flex-grow justify-center mb-0">
        {content}
      </div>
      <DialogFooter>{footer}</DialogFooter>
    </DialogContent>
  );
}
